import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { faPlus, faSpinner } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import AwesomeIcon from "../../../AwesomeIcon";
import { CARD_SECTION, CARD_SECTION_LABEL } from "./cardStyles";
var ReportAITags = function ReportAITags(_ref) {
  var tags = _ref.tags,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "AI Tags" : _ref$title,
    onApplyTag = _ref.onApplyTag,
    applyingTagId = _ref.applyingTagId,
    className = _ref.className;
  if (!tags.length) return null;

  // Applied (resolved) tags first; selectable (un-applied) tags at the end.
  var orderedTags = _toConsumableArray(tags).sort(function (a, b) {
    return (b.applied ? 1 : 0) - (a.applied ? 1 : 0);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(CARD_SECTION, "flex gap-2 flex-wrap items-center", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: CARD_SECTION_LABEL
  }, title), orderedTags.map(function (tag) {
    var canApply = !!onApplyTag && tag.applied === false;
    var isApplying = applyingTagId === tag.id;
    return /*#__PURE__*/React.createElement("button", {
      key: tag.id,
      type: "button",
      disabled: !canApply || isApplying,
      onClick: function onClick(e) {
        e.stopPropagation();
        if (canApply && !isApplying) onApplyTag === null || onApplyTag === void 0 || onApplyTag(tag);
      },
      title: canApply ? "Apply tag to patient" : undefined,
      className: classNames("rounded-full px-3 py-1 text-[10px] select-none transition-all duration-200 inline-flex items-center gap-1", canApply ? "bg-teal-50 dark:bg-teal-900/30 border border-teal-300 dark:border-teal-700 text-teal-700 dark:text-teal-300 cursor-pointer hover:bg-teal-600/20 dark:hover:bg-teal-900 active:scale-95" : "bg-gray-200/50 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 cursor-default", isApplying && "opacity-60 cursor-wait")
    }, canApply && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: isApplying ? faSpinner : faPlus,
      className: classNames("w-2.5 h-2.5", isApplying && "animate-spin")
    }), tag.label);
  }));
};
export default ReportAITags;